import React, { useCallback, useState } from 'react';
import { TagGroupGq } from '../../../../../graphql/projects/models/TagGroupGq';
import { projectsApiService } from '../../../../../graphql/projects/projectsApiService';
import VoxelButton from '../../../../../components/voxel/Buttons/VoxelButton';
import { ConflictTableState } from './ConflictsTable/logic/useConflictTableState';

export interface BulkSkipButtonProps {
  tableState: ConflictTableState;
  tagGroup: TagGroupGq;
  disabled: boolean;
  reload: () => Promise<any>;
  resetSelection: () => void;
}

const BulkSkipButton: React.FC<BulkSkipButtonProps> = ({
  tableState,
  tagGroup,
  disabled,
  reload,
  resetSelection,
}) => {
  const [loading, setLoading] = useState(false);

  const deleteSelectedMutation = projectsApiService.mutations.tags.useDeleteConflicts();
  const handleAction = useCallback(() => {
    setLoading(true);
    deleteSelectedMutation({
      tagGroupId: tagGroup.id,
      keywordQuery: {
        filtering: tableState.backendFilterState,
        selecting: tableState.backendSelectionState,
      },
    })
      .then(reload)
      .finally(() => {
        setLoading(false), resetSelection();
      });
  }, [tableState.backendFilterState, tableState.selectionState, reload]);

  return (
    <VoxelButton
      onClick={handleAction}
      disabled={disabled || loading}
      title='Skip'
      color='primary'
      shape='square'
      size='md'
    />
  );
};

export default BulkSkipButton;
